export default {"src":"/_next/static/media/404.290f36df.svg","height":345,"width":435,"blurWidth":0,"blurHeight":0};